import React from 'react';
import { PropTypes } from 'prop-types';
import { injectIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { history } from 'containers/App';
import LocalisedMessage from 'components/Common/LocalisedMessage';

const LogoutPage = ({ intl }) => {
  function login() {
    const actionUrl = intl?.messages?.sessionTimeoutActionUrl;

    if (actionUrl) {
      window.location = actionUrl;
      return;
    }

    history.push('/');
    window.location.reload();
  }

  return (<section className="logout-page">
    <div className="row">
      <div className="col-12 offset-sm-2 col-sm-8 offset-md-3 col-md-6 offset-lg-4 col-lg-4">
        <h1><LocalisedMessage id="loggedOut.title" /></h1>
        <span className="check-icon">
          <FontAwesomeIcon icon="check-circle" size="4x" />
        </span>
        <p><LocalisedMessage id="loggedOut.introduction" /></p>
        <p><LocalisedMessage id="loggedOut.content" /></p>
        <p><button type="button" className="btn btn-link" onClick={ () => login() }><LocalisedMessage id="loggedOut.buttonText" /></button></p>
      </div>
    </div>
  </section>);
};

LogoutPage.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
    messages: PropTypes.shape().isRequired
  }).isRequired,
};

export default injectIntl(LogoutPage);
